import { listProviderDialectPacks } from '../providers/providerDialectRegistry';
import type { ProviderDialectId } from '../providers/types';

export type NetworkShapeLibraryId = ProviderDialectId | 'base';

export const DEFAULT_NETWORK_SHAPE_LIBRARY_ID: NetworkShapeLibraryId = 'aws';

export const NETWORK_SHAPE_LIBRARY_ORDER: readonly NetworkShapeLibraryId[] = [
  'base',
  'aws',
  'azure',
  'gcp',
  'kubernetes',
  'generic',
];

const PROVIDER_PACKS_BY_ID = new Map(listProviderDialectPacks().map((pack) => [pack.id, pack]));

export function isNetworkShapeLibraryId(value: unknown): value is NetworkShapeLibraryId {
  return typeof value === 'string' && NETWORK_SHAPE_LIBRARY_ORDER.includes(value as NetworkShapeLibraryId);
}

export function getNetworkShapeLibraryLabel(id: NetworkShapeLibraryId): string {
  if (id === 'base') return 'Base network';
  if (id === 'aws') return 'AWS';
  return PROVIDER_PACKS_BY_ID.get(id)?.name ?? id.toUpperCase();
}

export function getNetworkShapeLibraryDescription(id: NetworkShapeLibraryId): string {
  if (id === 'base') return 'Routers, switches, firewalls, servers, databases, users, and internet boundaries.';
  if (id === 'aws') return 'AWS architecture icons and resource shapes.';
  return PROVIDER_PACKS_BY_ID.get(id)?.description ?? 'Provider-specific architecture shapes.';
}

export const NETWORK_SHAPE_LIBRARY_OPTIONS = NETWORK_SHAPE_LIBRARY_ORDER.map((id) => ({
  id,
  label: getNetworkShapeLibraryLabel(id),
  description: getNetworkShapeLibraryDescription(id),
}));
